import { useRouter } from 'next/router';
import React from 'react';
import { intToString } from '../../../Utils/helper';
import { downloadAppHandler } from '../../../Utils/redirections';
import { Flex } from '../../ArticlePage/ArticleDetail/styled';
import {
  CardShortDetail,
  FollowButton,
  PostAndFollowers,
  TopicCardStyled,
  TopicHeading,
} from './styled';
import { fireClickedFollowEvent } from '../../../Utils/useFirebase';

export default function TopicInfoCard(props) {
  const { tagData, installLink } = props;
  const router = useRouter();

  return (
    <TopicCardStyled>
      <Flex>
        <div>
          <TopicHeading>{tagData?.description}</TopicHeading>
          <PostAndFollowers padding="8px 0 0">
            <PostAndFollowers>
              <img src="/images/comment_dark.svg" alt="" />
              <span>{intToString(tagData?.contentCount)} Posts</span>
            </PostAndFollowers>

            <PostAndFollowers>
              <img src="/images/people_group.svg" alt="" />
              <span>{intToString(tagData?.following)} Followers</span>
            </PostAndFollowers>
          </PostAndFollowers>
        </div>

        <FollowButton
          onClick={() => {
            fireClickedFollowEvent(tagData?.description, installLink);
            downloadAppHandler();
          }}
        >
          + Follow
        </FollowButton>
      </Flex>
      <CardShortDetail>{tagData?.meta_description}</CardShortDetail>
    </TopicCardStyled>
  );
}
